// extracted by mini-css-extract-plugin
export default {"container":"DashboardLayout_container__wfDA5"};